import { TextField } from "@mui/material";
import type React from "react";
import { useMemo } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { useField } from "@tanstack/react-form";
import IconButton from "@mui/material/IconButton";
import Close from "@mui/icons-material/Close";

import type { AttributeInputProps } from "./types.ts";
import "./attribute-filter.css"

export const Palivo: React.FC<AttributeInputProps> = (
  {
    overviewForm,
    attributesList,
    allAds,
  }) => {
  const field = useField({
    form: overviewForm,
    // biome-ignore lint/nursery/noSecrets: ...
    name: "DetailCategoryFilter.Palivo",
  });
  const value = useMemo(() => field.state.value, [ field.state.value ])

  const attribute = useMemo(() => (
    attributesList.find((attr) => attr.name === "Palivo")
  ), [ attributesList ]);

  const palivoNames: string[] = useMemo(() => {
    const unique: Record<string, string> = {};
    for (const item of allAds) {
      if (item.attributes.model) {
        const palivo = item.attributes.palivo;
        if (palivo) {
          unique[palivo] = palivo;
        }
      }
    }
    const result = Object.keys(unique).toSorted((a: string, b: string) => a.localeCompare(b));
    return result;
  }, [ allAds ]);

  if (!attribute) {
    return null;
  }

  return (
    <div
      className={"SZAutoComplete"} // items are inserted after Autocomplete
    >
      <Autocomplete
        value={value ?? null}
        size="small"
        disablePortal={true}
        fullWidth={true}
        options={palivoNames}
        onChange={(_e, value) => {
          // setFilterAtom(value ?? ""); // do not reload page
          field.setValue(value ?? "");
        }}
        renderInput={(params) => (
          <TextField {...params} color="secondary" variant="filled" label={"Palivo"}/>
        )}
        clearIcon={
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => {
                      field.setValue("");
                    }}
                  >
                    <Close />
                  </IconButton>
        }
          />
    </div>
  )
};
